'use strict'

import axios from 'axios'

export const mutations = {
  'ATUALIZA_MODAL' (state, obj) {
    state.Modal = obj
    document.getElementById('senhaModal').focus()
  },
  'UPDATE_LOADER' (state, obj) {
    state.Loader = obj
  },
  'OK_CLICK_MODAL' (state, obj, vue) {
    state.Modal = obj
    if (obj.tipo === 'DOWNLOAD') {
      if (obj.senha === '') {
        state.Modal.titulo = 'Sorry...'
        state.Modal.mensagem = 'The key is required. :('
        state.Modal.tipo = 'WARNING'
        state.Modal.inputvisible = false
        state.Modal.btnokvisible = false

        setTimeout(function () {
          jQuery('#modal1').modal('close')
        }, 3000)

        return
      }

      const URL = `https://juscilan-be.fly.dev/file/Juscilan-Moreto-Nodejs-Phone-5511981671595.pdf?password=${obj.senha}`

      axios.get(URL).then(() => {
        window.location = URL
        state.Modal.senha = ''
        state.Modal.tipo = 'WARNING'
        jQuery('#modal1').modal('close')
      }).catch(() => {
        state.Modal.titulo = 'Sorry...'
        state.Modal.mensagem = 'The key is invalid.'
        state.Modal.tipo = 'WARNING'
        state.Modal.senha = ''
        state.Modal.inputvisible = false
        state.Modal.btnokvisible = false

        document.getElementById('senhaModal').focus()

        setTimeout(function () {
          jQuery('#modal1').modal('close')
          state.Modal.senha = ''
        }, 3000)

        state.Modal.senha = ''
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js